module.exports = __webpack_public_path__ + "static/media/host_greets_you.131206c2.svg";